/* SolarSprout theme scripts. No dependencies. */
(function () {
  'use strict';

  var theme = window.theme || { routes: {}, strings: {} };
  var routes = theme.routes;
  var root = (routes.root || '/').replace(/\/$/, '');

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function fetchJSON(url, options) {
    options = options || {};
    options.headers = Object.assign({ 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }, options.headers || {});
    return fetch(url, options).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok || data.status) {
          var err = new Error(data.description || data.message || theme.strings.error);
          err.data = data;
          throw err;
        }
        return data;
      });
    });
  }

  function formatMoney(cents) {
    var format = theme.moneyFormat || '${{amount}}';
    cents = typeof cents === 'string' ? parseInt(cents.replace('.', ''), 10) : cents;
    function fmt(n, decimals, thousands, decimal) {
      decimals = decimals === undefined ? 2 : decimals;
      var parts = (n / 100).toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + (thousands || ','));
      return parts.join(decimal || '.');
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      switch (key) {
        case 'amount_no_decimals': return fmt(cents, 0);
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'", '.');
        default: return fmt(cents, 2);
      }
    });
  }

  /* ---------- Focus trap + body lock for drawers ---------- */
  var lastFocus = null;
  function openLayer(el, focusTarget) {
    lastFocus = document.activeElement;
    el.hidden = false;
    document.body.classList.add('is-locked');
    requestAnimationFrame(function () {
      el.classList.add('is-open');
      var target = focusTarget || $('[tabindex="-1"], button, a, input', el);
      if (target) target.focus({ preventScroll: true });
    });
  }
  function closeLayer(el) {
    if (!el || el.hidden) return;
    el.classList.remove('is-open');
    document.body.classList.remove('is-locked');
    setTimeout(function () { if (!el.classList.contains('is-open')) el.hidden = true; }, 300);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  function trapFocus(e, el) {
    if (e.key !== 'Tab') return;
    var items = $$('a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])', el)
      .filter(function (n) { return n.offsetParent !== null; });
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ---------- Menu drawer ---------- */
  function initMenu() {
    var drawer = $('[data-menu-drawer]');
    if (!drawer) return;
    $$('[data-menu-open]').forEach(function (btn) {
      btn.addEventListener('click', function () { btn.setAttribute('aria-expanded', 'true'); openLayer(drawer, $('.drawer__panel', drawer)); });
    });
    $$('[data-menu-close]', drawer).forEach(function (btn) {
      btn.addEventListener('click', function () { closeLayer(drawer); $$('[data-menu-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); }); });
    });
    drawer.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeLayer(drawer); trapFocus(e, drawer); });
  }

  /* ---------- Search modal ---------- */
  function initSearch() {
    var modal = $('[data-search-modal]');
    if (!modal) return;
    $$('[data-search-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        // Keep the announcement bar visible above the search bar while it is on screen.
        var bar = $('.announcement');
        modal.style.top = (bar ? Math.max(0, Math.round(bar.getBoundingClientRect().bottom)) : 0) + 'px';
        var header = $('.header-wrapper'), content = $('.search-modal__content', modal);
        if (header && content) content.style.minHeight = header.offsetHeight + 'px';
        openLayer(modal, $('input[type="search"]', modal));
      });
    });
    $$('[data-search-close]', modal).forEach(function (btn) { btn.addEventListener('click', function () { closeLayer(modal); }); });
    modal.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeLayer(modal); });
  }

  /* ---------- Cart ---------- */
  var Cart = {
    drawer: function () { return $('[data-cart-drawer]'); },

    open: function () {
      var drawer = Cart.drawer();
      if (!drawer) { window.location.href = routes.cart; return; }
      openLayer(drawer, $('.drawer__panel', drawer));
      Cart.startTimer();
    },

    close: function () { closeLayer(Cart.drawer()); },

    updateCount: function (count) {
      $$('[data-cart-count]').forEach(function (el) {
        el.textContent = count;
        el.classList.toggle('is-empty', count === 0);
      });
    },

    // Re-renders the drawer (and the cart page sections when on /cart) with the Section Rendering API.
    refresh: function () {
      var ids = [];
      if (Cart.drawer()) ids.push('cart-drawer');
      var page = $('[data-cart-page]');
      var pageSections = [];
      if (page) {
        $$('.shopify-section').forEach(function (s) {
          if ($('[data-cart-page], [data-cart-footer]', s)) pageSections.push(s.id.replace('shopify-section-', ''));
        });
      }
      ids = ids.concat(pageSections);
      var cartPromise = fetchJSON(root + '/cart.js');
      if (!ids.length) return cartPromise.then(function (cart) { Cart.updateCount(cart.item_count); return cart; });
      var url = window.location.pathname + '?sections=' + ids.join(',');
      return Promise.all([fetch(url).then(function (r) { return r.json(); }), cartPromise]).then(function (results) {
        Cart.renderSections(results[0]);
        Cart.updateCount(results[1].item_count);
        return results[1];
      });
    },

    renderSections: function (sections) {
      Object.keys(sections || {}).forEach(function (id) {
        var html = new DOMParser().parseFromString(sections[id], 'text/html');
        if (id === 'cart-drawer') {
          var fresh = $('[data-cart-drawer-inner]', html);
          var current = $('[data-cart-drawer-inner]', Cart.drawer());
          if (fresh && current) current.innerHTML = fresh.innerHTML;
        } else {
          var target = document.getElementById('shopify-section-' + id);
          var source = html.getElementById('shopify-section-' + id) || html.body;
          if (target && source) target.innerHTML = source.innerHTML;
        }
      });
      Cart.startTimer();
    },

    add: function (formData) {
      return fetch(routes.cartAdd + '.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
        body: formData
      }).then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok || data.status) {
            var err = new Error(data.description || data.message || theme.strings.error);
            err.data = data;
            throw err;
          }
          return data;
        });
      });
    },

    change: function (line, quantity) {
      return fetchJSON(routes.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      });
    },

    // Reservation timer kept per browser tab session so it does not reset on every page.
    timerHandle: null,
    startTimer: function () {
      var el = $('[data-cart-timer]');
      if (!el) return;
      var valueEl = $('[data-cart-timer-value]', el);
      var minutes = parseInt(el.getAttribute('data-minutes'), 10) || 10;
      var key = 'solarsprout:cart-timer';
      var end;
      try { end = parseInt(sessionStorage.getItem(key), 10); } catch (e) { end = 0; }
      if (!end || end < Date.now()) {
        end = Date.now() + minutes * 60000;
        try { sessionStorage.setItem(key, String(end)); } catch (e) { /* storage blocked */ }
      }
      clearInterval(Cart.timerHandle);
      function tick() {
        var left = Math.max(0, end - Date.now());
        var m = Math.floor(left / 60000);
        var s = Math.floor((left % 60000) / 1000);
        if (valueEl) valueEl.textContent = m + ':' + (s < 10 ? '0' : '') + s;
        if (left <= 0) {
          clearInterval(Cart.timerHandle);
          el.classList.add('is-expired');
          try { sessionStorage.removeItem(key); } catch (e) { /* storage blocked */ }
        }
      }
      tick();
      Cart.timerHandle = setInterval(tick, 1000);
    }
  };
  window.SolarSproutCart = Cart;

  function afterAdd() {
    if (theme.cartType === 'drawer' && Cart.drawer()) {
      return Cart.refresh().then(function () { Cart.open(); });
    }
    window.location.href = routes.cart;
  }

  function initCart() {
    // Header cart icon opens the drawer instead of going to /cart.
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-cart-open]');
      if (opener && theme.cartType === 'drawer' && Cart.drawer()) {
        e.preventDefault();
        Cart.open();
        return;
      }
      if (e.target.closest('[data-cart-close]')) { Cart.close(); return; }

      var upsell = e.target.closest('[data-upsell-add]');
      if (upsell) {
        upsell.disabled = true;
        var fd = new FormData();
        fd.append('id', upsell.getAttribute('data-upsell-add'));
        fd.append('quantity', '1');
        Cart.add(fd).then(Cart.refresh).catch(function (err) {
          upsell.disabled = false;
          window.alert(err.message);
        });
        return;
      }

      var qtyBtn = e.target.closest('[data-qty-change]');
      if (qtyBtn) {
        var item = qtyBtn.closest('[data-line]');
        var input = $('[data-qty-input]', item);
        var next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(qtyBtn.getAttribute('data-qty-change'), 10));
        input.value = next;
        changeLine(item, next);
        return;
      }

      var remove = e.target.closest('[data-qty-remove]');
      if (remove && remove.closest('[data-line]')) {
        e.preventDefault();
        changeLine(remove.closest('[data-line]'), 0);
      }
    });

    document.addEventListener('change', function (e) {
      var input = e.target.closest('[data-qty-input]');
      if (input) changeLine(input.closest('[data-line]'), Math.max(0, parseInt(input.value, 10) || 0));
    });

    var drawer = Cart.drawer();
    if (drawer) drawer.addEventListener('keydown', function (e) { if (e.key === 'Escape') Cart.close(); trapFocus(e, drawer); });

    // Discount codes: applied through /discount/CODE, which stores the code for checkout.
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-discount-form]');
      if (!form) return;
      e.preventDefault();
      var input = $('input[name="discount"]', form);
      var message = form.parentNode.querySelector('[data-discount-message]');
      var code = (input.value || '').trim();
      message.hidden = false;
      message.classList.remove('is-error', 'is-success');
      if (!code) {
        message.textContent = message.getAttribute('data-empty');
        message.classList.add('is-error');
        return;
      }
      fetch(root + '/discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
        .then(function () { return Cart.refresh(); })
        .then(function () {
          var msg = Cart.drawer() && Cart.drawer().querySelector('[data-discount-message]');
          if (msg) {
            msg.hidden = false;
            msg.textContent = msg.getAttribute('data-applied').replace('__CODE__', code);
            msg.classList.add('is-success');
          }
        });
    });

    if (theme.cartType === 'drawer' && drawer && $('[data-cart-timer]', drawer)) Cart.startTimer();
  }

  var changeQueue = Promise.resolve();
  function changeLine(item, quantity) {
    if (!item) return;
    item.classList.add('is-loading');
    var line = parseInt(item.getAttribute('data-line'), 10);
    changeQueue = changeQueue.then(function () {
      return Cart.change(line, quantity).then(Cart.refresh).catch(function (err) {
        item.classList.remove('is-loading');
        window.alert(err.message);
      });
    });
  }

  /* ---------- Product forms ---------- */
  function initProductForms() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-product-form], [data-card-form]');
      if (!form) return;
      if (!window.fetch || !window.FormData) return; // let the browser post normally
      e.preventDefault();

      var button = $('[name="add"]', form) || (e.submitter || null);
      var errorBox = $('[data-form-error]', form);
      if (button) {
        if (button.getAttribute('aria-disabled') === 'true') return;
        button.setAttribute('aria-disabled', 'true');
        button.classList.add('is-loading');
      }
      if (errorBox) errorBox.hidden = true;

      var skipCart = form.getAttribute('data-skip-cart') === 'true';
      var formData = new FormData(form);
      // Quantity fields can live outside the form (form="..." attribute).
      if (form.id && !formData.get('quantity')) {
        var outside = document.querySelector('input[name="quantity"][form="' + form.id + '"]');
        if (outside) formData.set('quantity', outside.value);
      }

      Cart.add(formData)
        .then(function () {
          if (skipCart) {
            window.location.href = root + '/checkout';
            return;
          }
          return afterAdd();
        })
        .catch(function (err) {
          if (errorBox) {
            errorBox.textContent = err.message;
            errorBox.hidden = false;
          } else {
            window.alert(err.message);
          }
        })
        .then(function () {
          if (button && !skipCart) {
            button.removeAttribute('aria-disabled');
            button.classList.remove('is-loading');
          }
        });
    });

    // Restore buttons when the page is shown again from the back/forward cache (after checkout redirect).
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      $$('[data-product-form] [name="add"], [data-card-form] [name="add"]').forEach(function (b) {
        b.removeAttribute('aria-disabled');
        b.classList.remove('is-loading');
      });
    });

    // Quantity +/- on product pages.
    document.addEventListener('click', function (e) {
      var step = e.target.closest('[data-qty-step]');
      if (!step) return;
      var input = $('input', step.closest('[data-quantity]'));
      var next = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(step.getAttribute('data-qty-step'), 10));
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* ---------- Variant picker ---------- */
  function initVariantPickers() {
    $$('[data-variant-picker]').forEach(function (picker) {
      var json = $('[data-variants]', picker);
      if (!json) return;
      var variants = JSON.parse(json.textContent);
      var section = picker.closest('[data-product-section]');
      var form = document.getElementById(picker.getAttribute('data-form-id'));

      picker.addEventListener('change', function () {
        var selected = [];
        $$('fieldset', picker).forEach(function (fs) {
          var checked = $('input:checked', fs);
          selected.push(checked ? checked.value : null);
        });
        var variant = variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === selected[i]; });
        });
        updateVariant(section, form, variant);
      });
    });
  }

  function updateVariant(section, form, variant) {
    var button = form && $('[data-add-button]', form);
    var label = button && $('[data-add-label]', button);
    if (!variant) {
      if (button) button.disabled = true;
      if (label) label.textContent = theme.strings.soldOut;
      return;
    }
    if (form) {
      var idInput = $('[data-variant-id]', form);
      if (idInput) idInput.value = variant.id;
    }
    if (button) {
      button.disabled = !variant.available;
      if (label) {
        if (!button.getAttribute('data-default-label')) button.setAttribute('data-default-label', label.textContent.trim());
        label.textContent = variant.available ? button.getAttribute('data-default-label') : theme.strings.soldOut;
      }
    }
    var sticky = $('[data-sticky-buy-button]');
    if (sticky) sticky.disabled = !variant.available;

    $$('[data-price]', section).forEach(function (price) {
      var current = $('[data-price-current]', price);
      var compare = $('[data-price-compare]', price);
      var badge = $('[data-price-badge]', price);
      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (current) current.textContent = formatMoney(variant.price);
      if (compare) {
        compare.hidden = !onSale;
        compare.textContent = onSale ? formatMoney(variant.compare_at_price) : '';
      }
      if (badge) {
        badge.hidden = !onSale;
        var pct = $('[data-price-badge-percent]', badge);
        if (pct && onSale) pct.textContent = Math.floor((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
      }
    });

    $$('input[name="id"]', section).forEach(function (input) {
      if (input.closest('.product__terms-form')) input.value = variant.id;
    });

    if (variant.featured_media && section) {
      var gallery = $('[data-gallery]', section);
      var slide = gallery && $('[data-media-id="' + variant.featured_media.id + '"]', gallery);
      if (slide) goToSlide(gallery, parseInt(slide.getAttribute('data-index'), 10));
    }

    if (section && section.getAttribute('data-product-url') && window.history.replaceState && $('[data-sticky-buy]')) {
      window.history.replaceState({}, '', section.getAttribute('data-product-url') + '?variant=' + variant.id);
    }
  }

  /* ---------- Gallery ---------- */
  function goToSlide(gallery, index) {
    var track = $('[data-gallery-slides]', gallery);
    var slides = $$('.gallery__slide', track);
    if (!slides[index]) return;
    track.scrollTo({ left: slides[index].offsetLeft - track.offsetLeft, behavior: 'smooth' });
    setActiveThumb(gallery, index);
  }

  function setActiveThumb(gallery, index) {
    $$('.gallery__slide', gallery).forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
    $$('[data-thumb-index]', gallery).forEach(function (t) {
      var active = parseInt(t.getAttribute('data-thumb-index'), 10) === index;
      t.classList.toggle('is-active', active);
      if (active) {
        var strip = t.closest('[data-gallery-thumbs]');
        var li = t.parentNode;
        if (strip) strip.scrollTo({ left: li.offsetLeft - strip.offsetLeft - strip.clientWidth / 2 + li.clientWidth / 2, behavior: 'smooth' });
      }
    });
  }

  function initGalleries() {
    $$('[data-gallery]').forEach(function (gallery) {
      var track = $('[data-gallery-slides]', gallery);
      if (!track) return;
      var count = $$('.gallery__slide', track).length;
      var current = 0;

      $$('[data-thumb-index]', gallery).forEach(function (thumb) {
        thumb.addEventListener('click', function () { goToSlide(gallery, parseInt(thumb.getAttribute('data-thumb-index'), 10)); });
      });
      var prev = $('[data-thumbs-prev]', gallery);
      var next = $('[data-thumbs-next]', gallery);
      // The arrows page the thumbnail strip by a full set (5 on desktop, 4 on phones), wrapping at the ends.
      var strip = $('[data-gallery-thumbs]', gallery);
      function pageThumbs(dir) {
        if (!strip) return;
        var page = strip.clientWidth;
        var max = strip.scrollWidth - strip.clientWidth;
        var target = Math.round(strip.scrollLeft / page) * page + dir * page;
        if (target > max + 2) target = strip.scrollLeft >= max - 2 ? 0 : max;
        else if (target < -2) target = strip.scrollLeft <= 2 ? max : 0;
        strip.scrollTo({ left: Math.min(max, Math.max(0, target)), behavior: 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { pageThumbs(-1); });
      if (next) next.addEventListener('click', function () { pageThumbs(1); });

      var raf;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var index = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
          if (index !== current) {
            current = index;
            setActiveThumb(gallery, index);
            $$('video', track).forEach(function (v, i) { if (i !== index) v.pause(); });
          }
        });
      }, { passive: true });
    });
  }

  /* ---------- Media slider (reviews videos) ---------- */
  function initSliders() {
    $$('[data-slider]').forEach(function (slider) {
      var track = $('[data-slider-track]', slider);
      var prev = $('[data-slider-prev]', slider);
      var next = $('[data-slider-next]', slider);
      if (!track) return;

      function step() {
        var slide = $('.media-slider__slide', track);
        if (!slide) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
        return slide.getBoundingClientRect().width + gap;
      }
      function update() {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();

      // Auto-rotate: one slide every few seconds to the end, then back to the start, and so on.
      // Waits while the pointer is over it, after any swipe or arrow click, and while it is off screen.
      var seconds = parseFloat(slider.getAttribute('data-autoplay'));
      if (!seconds) return;
      var dir = 1, hovering = false, visible = false, lastMove = Date.now();
      function touched() { lastMove = Date.now(); }
      var area = track.parentNode;
      area.addEventListener('mouseenter', function () { hovering = true; });
      area.addEventListener('mouseleave', function () { hovering = false; touched(); });
      ['pointerdown', 'wheel', 'touchstart', 'keydown'].forEach(function (type) {
        slider.addEventListener(type, touched, { passive: true });
      });
      if (prev) prev.addEventListener('click', touched);
      if (next) next.addEventListener('click', touched);
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          visible = entries[0].isIntersecting;
          if (visible) touched();
        }, { threshold: 0.3 }).observe(track);
      } else {
        visible = true;
      }
      setInterval(function () {
        if (hovering || !visible || document.hidden || Date.now() - lastMove < seconds * 1000) return;
        var max = track.scrollWidth - track.clientWidth;
        if (max <= 2) return;
        if (dir > 0 && track.scrollLeft >= max - 2) dir = -1;
        else if (dir < 0 && track.scrollLeft <= 2) dir = 1;
        track.scrollBy({ left: dir * step(), behavior: 'smooth' });
        touched();
      }, 500);
    });
  }

  // Slider videos play muted while on screen; tapping one pauses or resumes it.
  function playVideo(video) {
    var p = video.play();
    if (p && p.catch) p.catch(function () {});
  }
  function initVideoToggles() {
    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-video-toggle]');
      if (!toggle) return;
      var media = toggle.closest('[data-slide-video]');
      var video = media && $('video', media);
      if (!video) return;
      if (video.paused) {
        video.removeAttribute('data-user-paused');
        playVideo(video);
      } else {
        video.setAttribute('data-user-paused', '');
        video.pause();
      }
    });
    var videos = $$('[data-slide-video] video');
    // Covers load only once the slider is near the screen, then all of that slider's covers at once so swiping never shows a blank slide.
    var lazyPosters = $$('[data-slide-video] video[data-poster]');
    function loadPosters(scope) {
      $$('video[data-poster]', scope).forEach(function (v) {
        v.setAttribute('poster', v.getAttribute('data-poster'));
        v.removeAttribute('data-poster');
      });
    }
    if (lazyPosters.length) {
      if ('IntersectionObserver' in window) {
        var posterIo = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            loadPosters(entry.target.closest('.media-slider__track') || document);
            posterIo.unobserve(entry.target);
          });
        }, { rootMargin: '600px 0px' });
        lazyPosters.forEach(function (v) { posterIo.observe(v); });
      } else {
        loadPosters(document);
      }
    }
    if ('IntersectionObserver' in window && videos.length) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var v = entry.target;
          if (entry.isIntersecting) { if (!v.hasAttribute('data-user-paused')) playVideo(v); }
          else v.pause();
        });
      }, { threshold: 0.4 });
      videos.forEach(function (v) { io.observe(v); });
    }
    // Media events do not bubble, so listen in the capture phase (also covers sections reloaded in the editor).
    ['play', 'pause', 'ended'].forEach(function (type) {
      document.addEventListener(type, function (e) {
        var media = e.target.closest && e.target.closest('[data-slide-video]');
        if (media) media.classList.toggle('is-playing', type === 'play');
      }, true);
    });
  }

  /* ---------- Carousels (announcement bar, review slider) ---------- */
  function initRotators() {
    $$('[data-rotator]').forEach(function (rotator) {
      if (rotator.hasAttribute('data-rotator-ready')) return;
      var track = $('[data-rotator-track]', rotator);
      var items = $$('[data-rotator-item]', rotator);
      if (!track || items.length < 2) return;
      rotator.setAttribute('data-rotator-ready', '');
      var seconds = parseFloat(rotator.getAttribute('data-interval')) || 5;
      var index = 0;
      var paused = false;
      rotator.addEventListener('mouseenter', function () { paused = true; });
      rotator.addEventListener('mouseleave', function () { paused = false; });
      function show(i) {
        index = (i + items.length) % items.length;
        track.style.transform = 'translateX(' + (-index * 100) + '%)';
        items.forEach(function (item, n) { item.setAttribute('aria-hidden', String(n !== index)); });
      }
      show(0);
      var lastMove = Date.now();
      setInterval(function () {
        if (paused || dragging || document.hidden || Date.now() - lastMove < seconds * 1000) return;
        show(index + 1);
        lastMove = Date.now();
      }, 500);

      // Swipe with a finger or drag with the mouse; the slide follows the pointer.
      var startX = null, dx = 0, dragging = false, moved = false;
      rotator.addEventListener('pointerdown', function (e) {
        if (e.button !== 0) return;
        startX = e.clientX; dx = 0; moved = false;
      });
      rotator.addEventListener('pointermove', function (e) {
        if (startX === null) return;
        dx = e.clientX - startX;
        if (!dragging && Math.abs(dx) > 6) {
          dragging = true; moved = true;
          track.style.transition = 'none';
          if (rotator.setPointerCapture) rotator.setPointerCapture(e.pointerId);
        }
        if (dragging) track.style.transform = 'translateX(calc(' + (-index * 100) + '% + ' + dx + 'px))';
      });
      function endDrag() {
        if (startX === null) return;
        startX = null;
        if (!dragging) return;
        dragging = false;
        track.style.transition = '';
        show(Math.abs(dx) > Math.min(60, rotator.offsetWidth / 5) ? index + (dx < 0 ? 1 : -1) : index);
        lastMove = Date.now();
      }
      rotator.addEventListener('pointerup', endDrag);
      rotator.addEventListener('pointercancel', endDrag);
      rotator.addEventListener('dragstart', function (e) { e.preventDefault(); });
      // A drag should not also follow a link inside the slide.
      rotator.addEventListener('click', function (e) {
        if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
      }, true);
    });
  }

  /* ---------- Accordions: slide open and closed in 0.2s while the text fades (matches the old theme) ---------- */
  function initAccordions() {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.addEventListener('click', function (e) {
      var summary = e.target.closest('details.accordion > summary');
      if (!summary || reduce || !summary.parentNode.animate) return;
      e.preventDefault();
      var details = summary.parentNode;
      var content = $('.accordion__content', details);
      var opening = !details.open || details.hasAttribute('data-closing');
      var start = details.offsetHeight;
      if (details._anim) details._anim.cancel();
      if (details._fade) details._fade.cancel();
      details.removeAttribute('data-closing');
      // Measure the end height without painting in between.
      details.open = opening;
      var end = details.offsetHeight;
      details.open = true;
      details.style.clipPath = 'inset(0 -20px)';
      var anim = details._anim = details.animate(
        { height: [start + 'px', end + 'px'] },
        { duration: 200, easing: 'ease-in-out' }
      );
      if (content) {
        details._fade = content.animate(
          { opacity: opening ? [0, 1] : [1, 0] },
          { duration: 200, easing: 'ease', fill: 'forwards' }
        );
      }
      if (!opening) details.setAttribute('data-closing', '');
      anim.onfinish = function () {
        details._anim = null;
        details.style.clipPath = '';
        if (details._fade) { details._fade.cancel(); details._fade = null; }
        if (!opening) { details.open = false; details.removeAttribute('data-closing'); }
      };
    });
  }

  /* ---------- Country/region dropdown in the footer ---------- */
  function initDisclosures() {
    function close(d) {
      var btn = $('[data-disclosure-toggle]', d);
      btn.setAttribute('aria-expanded', 'false');
      $('[data-disclosure-list]', d).hidden = true;
    }
    document.addEventListener('click', function (e) {
      $$('[data-disclosure]').forEach(function (d) { if (!d.contains(e.target)) close(d); });
      var toggle = e.target.closest('[data-disclosure-toggle]');
      if (toggle) {
        var d = toggle.closest('[data-disclosure]');
        var list = $('[data-disclosure-list]', d);
        var open = toggle.getAttribute('aria-expanded') !== 'true';
        toggle.setAttribute('aria-expanded', String(open));
        list.hidden = !open;
        if (open) {
          var current = $('[aria-current="true"]', list);
          if (current) list.scrollTop = current.offsetTop - list.clientHeight / 2 + current.offsetHeight / 2;
        }
        return;
      }
      var option = e.target.closest('[data-disclosure-option]');
      if (option) {
        var form = option.closest('form');
        $('input[name="country_code"]', form).value = option.getAttribute('data-value');
        close(option.closest('[data-disclosure]'));
        form.submit();
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      $$('[data-disclosure]').forEach(function (d) {
        var btn = $('[data-disclosure-toggle]', d);
        if (btn.getAttribute('aria-expanded') === 'true') { close(d); btn.focus(); }
      });
    });
  }

  /* ---------- Hotspots ---------- */
  function initHotspots() {
    function setOpen(btn, open) {
      var spot = btn.closest('.hotspot');
      btn.setAttribute('aria-expanded', String(open));
      if (spot) {
        spot.classList.toggle('is-open', open);
        if (open) placeCard(spot);
      }
    }
    function closeAll(except) {
      $$('[data-hotspot-toggle][aria-expanded="true"]').forEach(function (btn) {
        if (btn !== except) setOpen(btn, false);
      });
    }
    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-hotspot-toggle]');
      if (toggle) {
        closeAll(toggle);
        setOpen(toggle, toggle.getAttribute('aria-expanded') !== 'true');
        return;
      }
      if (!e.target.closest('.hotspot__card')) closeAll();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
    $$('.hotspot').forEach(function (spot) {
      spot.addEventListener('mouseenter', function () { placeCard(spot); });
    });

    // Keep the card inside the image on desktop.
    function placeCard(spot) {
      var card = $('.hotspot__card', spot);
      var stageEl = spot.closest('[data-hotspots]');
      if (!card || !stageEl) return;
      spot.classList.remove('is-flipped-left', 'is-flipped-right', 'is-below');
      card.style.marginLeft = '';
      // Not enough room above (screen edge or sticky header)? Open the card below the button.
      var header = $('.header-wrapper');
      var hb = header ? header.getBoundingClientRect().bottom : 0;
      var topLimit = Math.max(10, hb > 0 ? hb + 10 : 0);
      var cr = card.getBoundingClientRect();
      if (cr.top < topLimit) {
        var dot = spot.getBoundingClientRect();
        if (window.innerHeight - dot.bottom > dot.top - topLimit) spot.classList.add('is-below');
      }
      // Still cut off? Scroll just enough to show the whole card.
      if (spot.classList.contains('is-open')) {
        cr = card.getBoundingClientRect();
        if (cr.bottom > window.innerHeight - 10) window.scrollBy({ top: cr.bottom - window.innerHeight + 10, behavior: 'smooth' });
        else if (cr.top < topLimit) window.scrollBy({ top: cr.top - topLimit, behavior: 'smooth' });
      }
      if (window.innerWidth < 750) {
        // Phones: card sits above the button; nudge it sideways so it stays on screen.
        var r = card.getBoundingClientRect();
        var shift = 0;
        if (r.left < 15) shift = 15 - r.left;
        else if (r.right > window.innerWidth - 15) shift = window.innerWidth - 15 - r.right;
        if (shift) card.style.marginLeft = shift + 'px';
        return;
      }
      var stage = stageEl.getBoundingClientRect();
      var rect = card.getBoundingClientRect();
      if (rect.right > stage.right) spot.classList.add('is-flipped-left');
      else if (rect.left < stage.left) spot.classList.add('is-flipped-right');
    }
  }

  /* ---------- Header: hide on scroll down, show on scroll up ---------- */
  function initStickyHeader() {
    var wrapper = $('.header-wrapper--sticky');
    var section = wrapper && wrapper.closest('.section-header');
    if (!section) return;
    var lastY = window.scrollY;
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var y = window.scrollY;
        var menuOpen = document.body.classList.contains('is-locked');
        if (!menuOpen) section.classList.toggle('is-hidden', y > lastY && y > section.offsetHeight);
        lastY = y;
        ticking = false;
      });
    }, { passive: true });
  }

  /* ---------- Sticky buy bar ---------- */
  function initStickyBuy() {
    var bar = $('[data-sticky-buy]');
    if (!bar) return;
    var form = document.getElementById(bar.getAttribute('data-form-id'));
    var button = form && $('[data-add-button]', form);
    if (!form || !button) return;

    bar.hidden = false;
    document.body.classList.add('has-sticky-buy');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        var below = entry.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', !entry.isIntersecting && below);
      });
      io.observe(button);
    }
    $('[data-sticky-buy-button]', bar).addEventListener('click', function () {
      if (form.requestSubmit) form.requestSubmit(button);
      else button.click();
    });
    mirrorBundleDeal(bar, form.closest('[data-product-info]'));
  }

  // The bar's button buys the deal picked in Kaching Bundles (it submits the main form), so the bar shows that
  // deal's name and price instead of the single kit's. Kaching draws and redraws its picker itself, hence the observer.
  function mirrorBundleDeal(bar, info) {
    var title = $('[data-sticky-buy-title]', bar);
    var current = $('[data-price-current]', bar);
    var compare = $('[data-price-compare]', bar);
    if (!info || !title || !current || !('MutationObserver' in window)) return;
    var queued = false;
    function setText(el, text) { if (el.textContent !== text) el.textContent = text; }
    function sync() {
      queued = false;
      var deal = $('.kaching-bundles__bars > .kaching-bundles__bar--selected', info);
      var name = deal && $('.kaching-bundles__bar-title', deal);
      var price = deal && $('.kaching-bundles__bar-price', deal);
      if (!name || !price) return;
      var full = $('.kaching-bundles__bar-full-price', deal);
      var was = full ? full.textContent.trim() : '';
      setText(title, name.textContent.trim());
      setText(current, price.textContent.trim());
      if (compare) {
        compare.hidden = !was;
        setText(compare, was);
      }
    }
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      setTimeout(sync, 50);
    }).observe(info, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class'] });
    sync();
  }

  /* ---------- Scroll to top ---------- */
  function initScrollTop() {
    var btn = $('[data-scroll-top]');
    if (!btn) return;
    btn.hidden = false;
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        btn.classList.toggle('is-visible', window.scrollY > 600);
        ticking = false;
      });
    }, { passive: true });
    btn.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  }

  /* ---------- Auto-submitting forms (filters, sort, country) ---------- */
  function initAutosubmit() {
    var timer;
    document.addEventListener('change', function (e) {
      var field = e.target.closest('[data-autosubmit]');
      if (!field || !field.form) return;
      var form = field.form;
      clearTimeout(timer);
      timer = setTimeout(function () {
        if (form.hasAttribute('data-facets-form')) {
          var params = new URLSearchParams(new FormData(form));
          // Drop empty price fields so they do not filter.
          Array.from(params.keys()).forEach(function (k) { if (!params.get(k)) params.delete(k); });
          window.location.search = params.toString();
        } else if (form.requestSubmit) {
          form.requestSubmit();
        } else {
          form.submit();
        }
      }, field.type === 'number' ? 600 : 0);
    });

    // Close an open filter when another opens or on outside click.
    document.addEventListener('click', function (e) {
      $$('[data-facet][open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
    });
  }

  /* ---------- Theme editor support ---------- */
  function initEditor() {
    if (!window.Shopify || !window.Shopify.designMode) return;
    document.addEventListener('shopify:section:load', function () {
      initGalleries(); initSliders(); initRotators(); initVariantPickers();
    });
    document.addEventListener('shopify:section:select', function (e) {
      if (e.target.querySelector('[data-cart-drawer]')) Cart.open();
    });
  }

  function init() {
    initMenu();
    initSearch();
    initCart();
    initProductForms();
    initVariantPickers();
    initGalleries();
    initSliders();
    initRotators();
    initAccordions();
    initDisclosures();
    initVideoToggles();
    initHotspots();
    initStickyHeader();
    initStickyBuy();
    initScrollTop();
    initAutosubmit();
    initEditor();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
